/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { useState } from 'react'
import { OptionCard, OptionCardList } from './styles'
import { ModernModalBackdrop, ModernVerticalModal } from '../../../styles/Modal'
import { IoCloseCircleSharp } from 'react-icons/io5'
import { MdOutlineAdminPanelSettings } from 'react-icons/md'
import { TbUserDollar } from 'react-icons/tb'
import { GrStorage } from 'react-icons/gr'
import { FaEye } from 'react-icons/fa'
import { FiShield } from 'react-icons/fi'

import { toast } from 'react-toastify'
import ModalAdmin from '../../../components/Modals/ModalAdmin'
import ModalGestor from '../../../components/Modals/ModalGestor'
import ModalDist from '../../../components/Modals/ModalDist'
import api from '../../../services/axios'
import { Campo, CampoDelimitado } from '../../../types/campos'
import ModalVisualizador from '../../../components/Modals/ModalVisualizador'
import { useAuth } from '../../../context/AuthContext'

interface UserCreateProps {
  isOpen: boolean
  setCloseModal: () => void
  onSuccess?: () => void
}

function UserCreate({ isOpen, setCloseModal, onSuccess }: UserCreateProps) {
  const { user } = useAuth()
  const [step, setStep] = useState<'select' | 'admin' | 'suporte' | 'gestor' | 'dist' | 'visualizador' | 'conferente'>('select')

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [nickname, setNickname] = useState('')
  const [fantasyName, setFantasyName] = useState('')
  const [phone, setPhone] = useState('')
  const [cnpj, setCnpj] = useState('')
  const [layout, setLayout] = useState<'posicao' | 'delimitador' | 'mtrix' | ''>('')
  const [gestor, setGestor] = useState('')
  const [envio, setEnvio] = useState('')
  const [typeFile, setTypeFile] = useState('')
  const [role, setRole] = useState('')
  const [status, setStatus] = useState('')
  const [codDist, setCodDist] = useState('')
  const [visualizador, setVisualizador] = useState('')
  const [response, setResponse] = useState('')
  const [loading, setLoading] = useState(false)
  const [regional, setRegional] = useState('')

  // Estados de Vínculo Específicos
  const [distGestor, setDistGestor] = useState<number | string>('')
  const [distsVisualizador, setDistsVisualizador] = useState<number[]>([])
  const [vincMarca, setVincMarca] = useState('')
  const [vincDist, setVincDist] = useState<number | string>('')

  const [campos_vendas, setCamposVendas] = useState<Campo[]>([])
  const [campos_clientes, setCamposClientes] = useState<Campo[]>([])
  const [campos_estoque, setCamposEstoque] = useState<Campo[]>([])
  const [campos_frocavenda, setCamposFrocavenda] = useState<Campo[]>([])
  const [campos_produtos, setCamposProdutos] = useState<Campo[]>([])

  const [campos_vendas_delimitado, setCamposVendasDelimitado] = useState<CampoDelimitado[]>([])
  const [campos_clientes_delimitado, setCamposClientesDelimitado] = useState<CampoDelimitado[]>([])
  const [campos_estoque_delimitado, setCamposEstoqueDelimitado] = useState<CampoDelimitado[]>([])
  const [campos_frocavenda_delimitado, setCamposFrocavendaDelimitado] = useState([])
  const [campos_produtos_delimitado, setCamposProdutosDelimitado] = useState<CampoDelimitado[]>([])

  if (!isOpen) return null

  // Formata telefone no padrão (62) 99999-9999
  const formatPhone = (value: string) => {
    const digits = value.replace(/\D/g, '')
    const match = digits.match(/^(\d{2})(\d{5})(\d{4})$/)
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`
    }
    return value
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value)
    setPhone(formatted)
  }

  const handleCloseAll = () => {
    setStep('select')
    setCloseModal()
    // Resetar campos
    setName('')
    setFantasyName('')
    setCnpj('')
    setResponse('')
    setEmail('')
    setPhone('')
    setGestor('')
    setTypeFile('')
    setLayout('')
    setStatus('')
    setRegional('')
    setEnvio('')
    setCodDist('')
    setVisualizador('')
    setPassword('')
    setRole('')
    setNickname('')
    setDistGestor('')
    setDistsVisualizador([])
    setVincMarca('')
    setVincDist('')
    setCamposVendas([])
    setCamposClientes([])
    setCamposEstoque([])
    setCamposFrocavenda([])
    setCamposProdutos([])
    setCamposVendasDelimitado([])
    setCamposClientesDelimitado([])
    setCamposEstoqueDelimitado([])
    setCamposFrocavendaDelimitado([])
    setCamposProdutosDelimitado([])
  }

  const handleClickDist = async () => {
    setLoading(true)
    if (!cnpj || !name || !fantasyName || !typeFile) {
      toast.error('Preencha todos os campos.')
      setLoading(false)
      return
    }

    if (layout === '') {
      toast.error('Selecione ao menos um campo para o distribuidor.')
      setLoading(false)
      return
    }

    try {
      await api.post('/dist/post', {
        name,
        fantasy_name: fantasyName,
        cnpj,
        response,
        email,
        telefone: phone,
        gestor_id: gestor,
        type_file: typeFile,
        layout,
        envio,
        cod_dist: codDist,
        visualizador: visualizador ? Number(visualizador) : null,
        status,
        regional,

        ...(layout === 'posicao' && {
          campos_vendas,
          campos_clientes,
          campos_estoque,
          campos_frocavenda,
          campos_produtos,
        }),
        ...(layout === 'delimitador' && {
          campos_vendas: campos_vendas_delimitado,
          campos_clientes: campos_clientes_delimitado,
          campos_estoque: campos_estoque_delimitado,
          campos_frocavenda: campos_frocavenda_delimitado,
          campos_produtos: campos_produtos_delimitado,
        }),
      })
      toast.success('Distribuidor salvo com sucesso!')
      handleCloseAll()
      if (onSuccess) onSuccess()
    } catch (error: any) {
      toast.error(
        `Erro ao salvar distribuidor: ${error.response?.data?.message || 'Erro desconhecido'}`,
      )
    } finally {
      setLoading(false)
    }
  }

  async function handleGestorCreate() {
    if (!email || !password || !name || !nickname || !phone) {
      toast.error('Preencha todos os campos obrigatórios.')
      setLoading(false)
      return
    }

    if (!email.includes('@') || password.length < 6) {
      toast.error('Email ou senha inválidos.')
      setLoading(false)
      return
    }

    setLoading(true)
    try {
      await api.post('users/post', {
        email,
        password,
        name,
        role: 'gestor',
        nickname,
        phone,
        dist_gestor: distGestor ? Number(distGestor) : undefined,
      })

      toast.success('Gestor criado e vinculado com sucesso!')
      handleCloseAll()
      if (onSuccess) onSuccess()
    } catch (error: any) {
      toast.error(`Erro ao cadastrar: ${error.response?.data?.error || error.response?.data?.message || 'Erro desconhecido'}`)
    } finally {
      setLoading(false)
    }
  }

  async function handleAdmCreate() {
    if (!email || !password || !name || !role || !nickname || !phone) {
      toast.error('Preencha todos os campos obrigatórios.')
      setLoading(false)
      return
    }

    if (!email.includes('@') || password.length < 6) {
      toast.error('Email ou senha inválidos.')
      setLoading(false)
      return
    }

    setLoading(true)
    try {
      await api.post('users/post', {
        email,
        password,
        name,
        role,
        nickname,
        phone,
        vinc_marca: role === 'conferente' ? (vincMarca || undefined) : undefined,
        vinc_dist: role === 'conferente' && vincDist ? String(vincDist) : undefined,
        dists_visualizador: role === 'visualizador' && distsVisualizador.length > 0 ? distsVisualizador : undefined,
      })

      toast.success('Usuário criado e configurado com sucesso!')
      handleCloseAll()
      if (onSuccess) onSuccess()
    } catch (error: any) {
      toast.error(`Erro ao cadastrar: ${error.response?.data?.error || error.response?.data?.message || 'Erro desconhecido'}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {step === 'select' && (
        <ModernModalBackdrop>
          <ModernVerticalModal style={{ maxWidth: '640px' }}>
            <div className="header">
              <h3>Novo Cadastro • Selecione o Perfil</h3>
              <button className="btn-close" onClick={handleCloseAll} type="button">
                <IoCloseCircleSharp />
              </button>
            </div>

            <div className="body" style={{ overflowY: 'auto', maxHeight: '80vh' }}>
              <p style={{ fontSize: '13px', color: '#94a3b8', margin: '0 0 16px 0', lineHeight: '1.5' }}>
                Cada perfil possui regras específicas de acesso e vinculação com distribuidores e marcas. Escolha a categoria correspondente:
              </p>

              <OptionCardList>
                {/* 1. GESTOR */}
                <OptionCard
                  type="button"
                  onClick={() => {
                    setRole('gestor')
                    setStep('gestor')
                  }}
                >
                  <div className="icon-wrapper" style={{ background: 'linear-gradient(135deg, #0284c7, #0369a1)', color: '#ffffff' }}>
                    <TbUserDollar />
                  </div>
                  <div className="text-wrapper">
                    <span className="name">Gestor Comercial (Apenas seu Distribuidor)</span>
                    <span className="desc">Acompanha faturamento, sellout e metas restrito estritamente ao seu distribuidor vinculado.</span>
                  </div>
                </OptionCard>

                {/* 2. VISUALIZADOR */}
                <OptionCard
                  type="button"
                  onClick={() => {
                    setRole('visualizador')
                    setStep('visualizador')
                  }}
                >
                  <div className="icon-wrapper" style={{ background: 'linear-gradient(135deg, #a855f7, #7e22ce)', color: '#ffffff' }}>
                    <FaEye />
                  </div>
                  <div className="text-wrapper">
                    <span className="name">Visualizador (Mais de 1 Distribuidor)</span>
                    <span className="desc">Acesso analítico para consultar relatórios e dashboards de múltiplos distribuidores selecionados.</span>
                  </div>
                </OptionCard>

                {/* 3. CONFERENTE */}
                <OptionCard
                  type="button"
                  onClick={() => {
                    setRole('conferente')
                    setStep('conferente')
                  }}
                >
                  <div className="icon-wrapper" style={{ background: 'linear-gradient(135deg, #ec4899, #be185d)', color: '#ffffff' }}>
                    <MdOutlineAdminPanelSettings />
                  </div>
                  <div className="text-wrapper">
                    <span className="name">Conferente (Múltiplas Marcas & Distribuidores)</span>
                    <span className="desc">Validação de arquivos de sellout e estoques, com permissão para uma ou mais marcas e distribuidores.</span>
                  </div>
                </OptionCard>

                {/* 4. SUPORTE */}
                <OptionCard
                  type="button"
                  onClick={() => {
                    setRole('suporte')
                    setStep('suporte')
                  }}
                >
                  <div className="icon-wrapper" style={{ background: 'linear-gradient(135deg, #0ea5e9, #0284c7)', color: '#ffffff' }}>
                    <MdOutlineAdminPanelSettings />
                  </div>
                  <div className="text-wrapper">
                    <span className="name">Suporte Operacional (Acesso Global)</span>
                    <span className="desc">Acesso amplo a logs de transferências, reprocessamento de arquivos e atendimento a distribuidores.</span>
                  </div>
                </OptionCard>

                {/* 5. ADMINISTRADOR (SUPER ADMIN) */}
                {user?.role === 'administrador' && (
                  <OptionCard
                    type="button"
                    onClick={() => {
                      setRole('administrador')
                      setStep('admin')
                    }}
                  >
                    <div className="icon-wrapper" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#ffffff' }}>
                      <FiShield />
                    </div>
                    <div className="text-wrapper">
                      <span className="name">Administrador (Super Admin)</span>
                      <span className="desc">Acesso total irrestrito: criação de administradores e gestão de infraestrutura (SMTP/IA).</span>
                    </div>
                  </OptionCard>
                )}

                {/* 6. DISTRIBUIDOR */}
                <OptionCard
                  type="button"
                  onClick={() => {
                    setRole('distribuidor')
                    setStep('dist')
                  }}
                >
                  <div className="icon-wrapper" style={{ background: 'linear-gradient(135deg, #64748b, #475569)', color: '#ffffff' }}>
                    <GrStorage />
                  </div>
                  <div className="text-wrapper">
                    <span className="name">Distribuidor (Unidade Parceira)</span>
                    <span className="desc">Cadastrar novo distribuidor parceiro com layouts de faturamento, estoque e sellout.</span>
                  </div>
                </OptionCard>
              </OptionCardList>
            </div>
          </ModernVerticalModal>
        </ModernModalBackdrop>
      )}

      {(step === 'admin' || step === 'suporte') && (
        <ModalAdmin
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          nickname={nickname}
          setNickname={setNickname}
          phone={phone}
          setPhone={setPhone}
          role={role}
          setRole={setRole}
          loading={loading}
          handlePhoneChange={handlePhoneChange}
          handleClick={handleAdmCreate}
          setCloseModal={handleCloseAll}
          handleBack={() => setStep('select')}
        />
      )}

      {step === 'gestor' && (
        <ModalGestor
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          nickname={nickname}
          setNickname={setNickname}
          phone={phone}
          setPhone={setPhone}
          role={role}
          setRole={setRole}
          loading={loading}
          handlePhoneChange={handlePhoneChange}
          handleClick={handleGestorCreate}
          setCloseModal={handleCloseAll}
          handleBack={() => setStep('select')}
          distGestor={distGestor}
          setDistGestor={setDistGestor}
        />
      )}

      {step === 'dist' && (
        <ModalDist
          name={name}
          setName={setName}
          fantasyName={fantasyName}
          setFantasyName={setFantasyName}
          cnpj={cnpj}
          setCnpj={setCnpj}
          response={response}
          regional={regional}
          setRegional={setRegional}
          setResponse={setResponse}
          email={email}
          setEmail={setEmail}
          gestor={gestor}
          visualizador={visualizador}
          codDist={codDist}
          setVisualizador={setVisualizador}
          setCodDist={setCodDist}
          setGestor={setGestor}
          typeFile={typeFile}
          setTypeFile={setTypeFile}
          layout={layout}
          setLayout={setLayout}
          setStatus={setStatus}
          status={status}
          envio={envio}
          setEnvio={setEnvio}
          loading={loading}
          handleClick={handleClickDist}
          setCloseModal={handleCloseAll}
          handlePhoneChange={handlePhoneChange}
          handleBack={() => setStep('select')}
          cliente={campos_clientes_delimitado}
          setCliente={setCamposClientesDelimitado}
          estoque={campos_estoque_delimitado}
          setEstoque={setCamposEstoqueDelimitado}
          forcaven={campos_frocavenda_delimitado}
          setForcaven={setCamposFrocavendaDelimitado}
          produtos={campos_produtos_delimitado}
          setProdutos={setCamposProdutosDelimitado}
          sellout={campos_vendas_delimitado}
          setSellout={setCamposVendasDelimitado}
        />
      )}

      {step === 'visualizador' && (
        <ModalVisualizador
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          nickname={nickname}
          setNickname={setNickname}
          phone={phone}
          setPhone={setPhone}
          role={role}
          setRole={setRole}
          loading={loading}
          handlePhoneChange={handlePhoneChange}
          handleClick={handleAdmCreate}
          setCloseModal={handleCloseAll}
          handleBack={() => setStep('select')}
          distsVisualizador={distsVisualizador}
          setDistsVisualizador={setDistsVisualizador}
        />
      )}

      {step === 'conferente' && (
        <ModalAdmin
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          nickname={nickname}
          setNickname={setNickname}
          phone={phone}
          setPhone={setPhone}
          role={role}
          setRole={setRole}
          loading={loading}
          handlePhoneChange={handlePhoneChange}
          handleClick={handleAdmCreate}
          setCloseModal={handleCloseAll}
          handleBack={() => setStep('select')}
          vincMarca={vincMarca}
          setVincMarca={setVincMarca}
          vincDist={vincDist}
          setVincDist={setVincDist}
        />
      )}
    </>
  )
}

export default UserCreate
